import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./authConfig"; // Ensure you have the correct loginRequest config
import { Unauthorized } from './components/shared/ErrorPage/ErrorPage';

const LOGIN_TIMESTAMP_KEY = "userLoginTimestamp"; // Key for storing login timestamp in session storage
const LOGIN_EXPIRY_TIME = 59 * 60 * 1000; // 1 hour (in milliseconds)

const RequireAuth = ({ children }) => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [isValidSession, setIsValidSession] = useState(null); // Initialize as `null` to indicate loading state
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    useEffect(() => {
        const loginTimestamp = sessionStorage.getItem(LOGIN_TIMESTAMP_KEY);
        const isLoginExpired =
            !loginTimestamp ||
            new Date().getTime() - new Date(loginTimestamp).getTime() > LOGIN_EXPIRY_TIME;

        if (isLoginExpired || !isAuthenticated) {
            setIsValidSession(false);
            setIsLoggingIn(true);

            instance
                .loginPopup({ ...loginRequest, prompt: "login" })
                .then(() => {
                    const currentTime = new Date().toISOString();
                    sessionStorage.setItem(LOGIN_TIMESTAMP_KEY, currentTime); // Save login timestamp
                    setIsValidSession(true);
                })
                .catch((error) => {
                    console.error("Login failed:", error);
                    setIsValidSession(false);
                })
                .finally(() => {
                    setIsLoggingIn(false); // Always stop loading
                });
        } else {
            setIsValidSession(true); // Session is valid
        }
    }, [isAuthenticated, instance]);

    if (isValidSession === null) {
        // While determining session validity, show a loading spinner or nothing
        return <div>Loading...</div>;
    }

    if (!isValidSession) {
        return <Unauthorized />; // Show Unauthorized if the session is invalid
    }

    return <>
    {children}
    </>; // Render protected content when session is valid
};

export default RequireAuth;
